import { backgroundTracksConf } from "@/config";
import { t } from "i18next";
import { Pencil, Youtube } from "lucide-react";

const dialogUiConfig = {
  nameFieldLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.nameFieldLabel"),
  nameFieldPlaceholder: t("mediaLibraryScreen.addUpdatePlaylistDialog.nameFieldPlaceholder"),
  tagsFieldLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.tagsFieldLabel"),
  tagsFieldPlaceholder: t("mediaLibraryScreen.addUpdatePlaylistDialog.tagsFieldPlaceholder"),
  nameFieldValidationMsg: t("mediaLibraryScreen.addUpdatePlaylistDialog.nameFieldValidationMsg"),
  playbackRateFieldLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.playbackRateFieldLabel"),
  playbackRateFieldValidationMsg: t("mediaLibraryScreen.addUpdatePlaylistDialog.playbackRateFieldValidationMsg"),
  backgroundTrackFieldLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.backgroundTrackFieldLabel"),
  backgroundTrackFieldPlaceholder: t("mediaLibraryScreen.addUpdatePlaylistDialog.backgroundTrackFieldPlaceholder"),
  backgroundTrackFieldValidationMsg: t("mediaLibraryScreen.addUpdatePlaylistDialog.backgroundTrackFieldValidationMsg"),
  createContext: {
    DialogTriggerIcon: Youtube,
    dialogTriggerLabelCommon: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.dialogTriggerLabelCommon"),
    dialogTriggerLabelUser: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.dialogTriggerLabelUser"),
    dialogHeaderTitle: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.dialogHeaderTitle"),
    dialogHeaderDescr: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.dialogHeaderDescr"),
    submitBtnLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.submitBtnLabel"),
    submitSuccessMessage: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.submitSuccessMessage"),
    submitErrorMessage: t("mediaLibraryScreen.addUpdatePlaylistDialog.createContext.submitErrorMessage"),
  },
  updateContext: {
    DialogTriggerIcon: Pencil,
    dialogTriggerLabelCommon: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.dialogTriggerLabelCommon"),
    dialogTriggerLabelUser: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.dialogTriggerLabelUser"),
    dialogHeaderTitle: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.dialogHeaderTitle"),
    dialogHeaderDescr: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.dialogHeaderDescr"),
    submitBtnLabel: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.submitBtnLabel"),
    submitSuccessMessage: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.submitSuccessMessage"),
    submitErrorMessage: t("mediaLibraryScreen.addUpdatePlaylistDialog.updateContext.submitErrorMessage"),
  },
  backgroundTrackOptions: Object.keys(backgroundTracksConf).map((key) => ({
    label: key,
    value: key,
  })),
  playbackRateOptions: [
    {
      label: t("mediaLibraryScreen.addUpdatePlaylistDialog.playbackRateValues.slow"),
      value: "0.75"
    },
    {
      label: t("mediaLibraryScreen.addUpdatePlaylistDialog.playbackRateValues.normal"),
      value: "1.00"
    }, 
    {
      label: t("mediaLibraryScreen.addUpdatePlaylistDialog.playbackRateValues.fast"),
      value: "1.25"
    },
  ],
};

export default dialogUiConfig;